 const brands = [
    {
      name: "Apple",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/2e7cdc22-5a5f.jpg?p=default&s=lg",
    },
    {
      name: "Xiaomi",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/cb96df6e-080f.jpg?p=default&s=lg",
    },
    {
      name: "Samsung",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/406a512d-e8dd.jpg?p=default&s=lg",
    },
    {
      name: "Vivo",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/20922c34-8afc.jpg?p=default&s=lg",
    },
    {
      name: "OnePlus",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/dfb6c340-010f.jpg?p=default&s=lg",
    },
    {
      name: "OPPO",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/ac5c9a7b-76b5.jpg?p=default&s=lg",
    },
    {
      name: "Realme",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/0124cc45-3a6c.jpg?p=default&s=lg",
    },
    {
      name: "Motorola",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/1dcd7fda-0141.jpg?p=default&s=lg",
    },
    {
      name: "Lenovo",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/4834825a-7f10.jpg?p=default&s=lg",
    },
    {
      name: "Nokia",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/fef4e5ae-6507.jpg?p=default&s=lg",
    },
    {
      name: "Honor",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/cfeaabff-69bf.jpg?p=default&s=lg",
    },
    {
      name: "Google",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/dacc50a2-77a9.jpg?p=default&s=lg",
    },
    {
      name: "POCO",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/3e072dc2-6d7b.jpg?p=default&s=lg",
    },
    {
      name: "Infinix",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/738cb1f1-7ddf.jpg?p=default&s=lg",
    },
    {
      name: "Tecno",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/55424ad4-0400.jpg?p=default&s=lg",
    },
    {
      name: "iQOO",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/e1b13cbc-ef06.jpg?p=default&s=lg",
    },
    {
      name: "Nothing",
      logoUrl: "https://s3no.cashify.in/cashify/brand/img/xhdpi/06bc74db-4d38.jpg?p=default&s=lg",
    },
  ];


  export default brands;